//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useRef } from 'react';
import { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import {
    CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT,
    CONFIRM_DIALOG_MESSAGE_DELETE_BANNER,
    // CONFIRM_DIALOG_MESSAGE_CANCEL,
    // CONFIRM_DIALOG_MESSAGE_CLEAR_ALL,
    CONFIRM_DIALOG_MESSAGE_DELETE_LOGO,
    CONFIRM_DIALOG_TITLE_DELETE_BANNER,
    // CONFIRM_DIALOG_TITLE_CANCEL,
    // CONFIRM_DIALOG_TITLE_CLEAR_ALL,
    CONFIRM_DIALOG_TITLE_DELETE_LOGO,
    DASHBOARD_PROFILE_BRANDING,
    ERROR_MESSAGE_FILE_NOT_ALLOWED,
    ERROR_MESSAGE_FILE_SIZE_NOT_OVER_15MB,
    ERROR_MESSAGE_FILE_SIZE_NOT_OVER_5MB,
    UPLOADED_VIDEO_STATUS_PROCESSING,
} from '../../common/constants';
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { changeEmpProfileToDraft } from '../../common/services/empMyProfileServices';
import { deleteCompanyBanner, deleteCompanyLogo, saveProfileBranding, resetEmpBrandingSeResults } from '../../common/services/empMyProfileServices';
import { extractBadContentFromResult } from '../../common/sightEngineHelper';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdButton from '../../common/elemental/AfitdButton';
import AfitdEditDialog from '../../common/elemental/AfitdEditDialog';
import AfitdProfilePicCropper from '../../common/elemental/AfitdProfilePicCropper';
import AfitdBannerCropper from '../../common/elemental/AfitdBannerCropper';
import AfitdLinearProgress from '../../common/elemental/AfitdLinearProgress';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdConfirmDialog from '../../common/elemental/AfitdConfirmDialog';
import AfitdMessageDialog from '../../common/elemental/AfitdMessageDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import BrandingLogoPreview from './BrandingLogoPreview';
import BrandingBannerPreview from './BrandingBannerPreview';
import LoadingGif from '../../assets/loading.gif';
import HorizontalLoadingGif from '../../assets/horizontalLoadingGif.gif';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isNil from 'lodash/isNil';
import _toUpper from 'lodash/toUpper';
import _last from 'lodash/last';
import _some from 'lodash/some';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
    titleContainer: {
        padding: '0 0 19px 0',
    },
    brandingLogoContainer: {
        display: 'flex',
        flexDirection: 'column',
        // [theme.breakpoints.down('sm')]: { alignItems: 'center' },
    },
    brandingBannerContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    imageSectionTop: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
    },
    logoDiv: {
        marginLeft: '24px',
    },
    bannerDiv: {
        marginLeft: '24px',
    },
    logoDetails: {
        fontSize: '14px',
        color: 'rgba(17, 30, 20, 0.4)',
    },
    bannerDetails: {
        fontSize: '14px',
        color: 'rgba(17, 30, 20, 0.4)',
        // marginLeft: '24px',
        // marginTop: '50px',
    },
    deleteLogoButton: {
        marginLeft: '10px',
    },
    deleteBannerButton: {
        marginLeft: '10px',
    },
    footerButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '80px',
    },
    imgBeforeCropContainer: { display: 'flex', justifyContent: 'center' },
    uploadLinearProgressContainer: { marginTop: 16 },
    hidden: { display: 'none' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        currentEmployer,
        props,
        source,
        // setSource,
        sourceBanner,
        // setSourceBanner,
        logoImage,
        bannerImage,
        // logoBlob,
        setLogoBlob,
        // bannerBlob,
        setBannerBlob,
        logoInputRef,
        bannerInputRef,
        progress,
        // setProgress,
        // isDirty,
        // setIsDirty,
        // isConfirmClearAllDialogOpen,
        // setIsConfirmClearAllDialogOpen,
        // isConfirmCloseDialogOpen,
        // setIsConfirmCloseDialogOpen,
        isConfirmDeleteLogoDialogOpen,
        // setIsConfirmDeleteLogoDialogOpen,
        isConfirmDeleteBannerDialogOpen,
        // setIsConfirmDeleteBannerDialogOpen,
        // clearFields,
        handleChangeLogoUploadInput,
        handleChangeBannerUploadInput,
        // handleClickClearAllButton,
        // handleCloseConfirmClearAllDialog,
        // handleClickConfirmClearAllDialogYes,
        // handleClickCancelButton,
        // handleCloseConfirmCancelDialog,
        // handleClickConfirmCancelDialogYes,
        handleClickDeleteLogoButton,
        handleCloseConfirmDeleteLogoDialog,
        handleClickConfirmDeleteLogoDialogYes,
        handleClickDeleteBannerButton,
        handleCloseConfirmDeleteBannerDialog,
        handleClickConfirmDeleteBannerDialogYes,
        handleUploadLogo,
        handleUploadBanner,
        cropLogoModalOpen,
        // setCropLogoModalOpen,
        cropBannerModalOpen,
        // setCropBannerModalOpen,
        handleCloseCropLogoModal,
        handleCloseCropBanneroModal,
        logoErrorMessage,
        // setLogoErrorMessage,
        bannerErrorMessage,
        // setBannerErrorMessage,
        makeProfilePublicDialog,
        setMakePofilePublicDialog,
        onConfrimChangeProfileType,
        openBadImageDialog,
        badImageDialogMessage,
        setOpenBadImageDialog,
        saveLoading,
        isPictureProcessing,
        isBannerProcessing,
        employerId,
        setSnackbarMessage,
        setSnackbarErrorMessage,
    } = params;
    const tier = _get(currentEmployer, 'tier');
    const { data, isPublic } = props;
    // const profilePicUrl = _get(data, 'profilePicUrl');
    const bannerUrl = _get(data, 'bannerUrl');

    const isValidLogoFile = !!!logoErrorMessage;
    const isValidBannerFile = !!!bannerErrorMessage;

    const defns = {
        brandingBannerSection: { isHidden: tier < 2, bannerUrl },
        brandingLogoPreview: { logoUrl: isPictureProcessing ? LoadingGif : source },
        brandingBannerPreview: { bannerUrl: isBannerProcessing ? HorizontalLoadingGif : sourceBanner },
        uploadLogoButton: {
            color: 'secondary',
            label: !source ? 'Upload Company Logo' : 'Change',
            component: 'label',
            disabled: isPictureProcessing,
            onClick: () => {
                if (isPublic) setMakePofilePublicDialog(true);
            },
        },
        uploadBannerButton: {
            color: 'secondary',
            label: !sourceBanner ? 'Upload Banner / Branded Backdrop' : 'Change',
            component: 'label',
            disabled: isBannerProcessing,
            onClick: () => {
                if (isPublic) setMakePofilePublicDialog(true);
            },
        },
        logoUploadInput: {
            type: 'file',
            hidden: true,
            ref: logoInputRef,
            onChange: handleChangeLogoUploadInput,
            accept: allowedFileTypes.join(', '),
        },
        bannerUploadInput: {
            type: 'file',
            hidden: true,
            ref: bannerInputRef,
            onChange: handleChangeBannerUploadInput,
            accept: allowedFileTypes.join(', '),
        },
        cropLogoModal: {
            open: cropLogoModalOpen,
            onClose: handleCloseCropLogoModal,
            label: 'Company Logo',
            inputRef: logoInputRef,
            actionButtonDefns: {
                cancel: {
                    disabled: false,
                    onClick: handleCloseCropLogoModal,
                },
                save: {
                    disabled: false,
                    onClick: handleUploadLogo,
                    label: saveLoading ? (
                        <>
                            <CircularProgress color="#ffffff" size={20} />
                            &nbsp; Saving
                        </>
                    ) : (
                        'Save Changes'
                    ),
                },
            },
        },
        cropBannerModal: {
            open: cropBannerModalOpen,
            onClose: handleCloseCropBanneroModal,
            label: 'Banner / Branded Backdrop',
            inputRef: bannerInputRef,
            actionButtonDefns: {
                cancel: {
                    disabled: false,
                    onClick: handleCloseCropBanneroModal,
                },
                save: {
                    disabled: false,
                    onClick: handleUploadBanner,
                    label: saveLoading ? (
                        <>
                            <CircularProgress color="#ffffff" size={20} />
                            &nbsp; Saving
                        </>
                    ) : (
                        'Save Changes'
                    ),
                },
            },
        },
        logoErrorText: {
            clsRedColor: true,
            value: logoErrorMessage,
            isHidden: isValidLogoFile,
        },
        bannerErrorText: {
            clsRedColor: true,
            value: bannerErrorMessage,
            isHidden: isValidBannerFile,
        },
        logoCropper: { file: logoImage, setBlob: setLogoBlob },
        bannerCropper: { file: bannerImage, setBlob: setBannerBlob },
        logoUploadLinearProgress: { variant: 'determinate', value: progress, isHidden: _isNil(progress) },
        bannerUploadLinearProgress: { variant: 'determinate', value: progress, isHidden: _isNil(progress) },
        titleText: {
            variant: 'h6',
            clsLightBold: true,
            value: DASHBOARD_PROFILE_BRANDING,
        },
        deleteLogoButton: {
            isHidden: !source,
            disabled: isPictureProcessing,
            onClick: () => {
                if (isPublic) setMakePofilePublicDialog(true);
                else handleClickDeleteLogoButton();
            },
        },
        deleteBannerButton: {
            isHidden: !sourceBanner,
            disabled: isBannerProcessing,
            onClick: () => {
                if (isPublic) setMakePofilePublicDialog(true);
                else handleClickDeleteBannerButton();
            },
        },
        // clearAllButton: {
        //     onClick: handleClickClearAllButton,
        // },
        // cancelButton: {
        //     disabled: !isDirty,
        //     onClick: handleClickCancelButton,
        // },
        // saveButton: {
        //     color: 'primary',
        //     disabled: !isDirty,
        //     onClick: handleUploadLogo,
        // },
        confirmDeleteLogoDialog: {
            title: CONFIRM_DIALOG_TITLE_DELETE_LOGO,
            open: isConfirmDeleteLogoDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_DELETE_LOGO,
            onConfirm: handleClickConfirmDeleteLogoDialogYes,
            onClose: handleCloseConfirmDeleteLogoDialog,
        },
        confirmDeleteBannerDialog: {
            title: CONFIRM_DIALOG_TITLE_DELETE_BANNER,
            open: isConfirmDeleteBannerDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_DELETE_BANNER,
            onConfirm: handleClickConfirmDeleteBannerDialogYes,
            onClose: handleCloseConfirmDeleteBannerDialog,
        },
        // confirmCancelDialog: {
        //     title: CONFIRM_DIALOG_TITLE_CANCEL,
        //     open: isConfirmCloseDialogOpen,
        //     message: CONFIRM_DIALOG_MESSAGE_CANCEL,
        //     onConfirm: handleClickConfirmCancelDialogYes.bind(null, setIsConfirmCloseDialogOpen),
        //     onClose: handleCloseConfirmCancelDialog.bind(null, setIsConfirmCloseDialogOpen),
        // },
        // confirmClearAllDialog: {
        //     title: CONFIRM_DIALOG_TITLE_CLEAR_ALL,
        //     open: isConfirmClearAllDialogOpen,
        //     message: CONFIRM_DIALOG_MESSAGE_CLEAR_ALL,
        //     onConfirm: handleClickConfirmClearAllDialogYes,
        //     onClose: () => setIsConfirmClearAllDialogOpen(false),
        // },
        // confirmClearAllDialogCancelButton: {
        //     onClick: handleCloseConfirmClearAllDialog.bind(null, setIsConfirmClearAllDialogOpen),
        // },
        // confirmClearAllDialogOkButton: {
        //     autoFocus: true,
        //     onClick: handleClickConfirmClearAllDialogYes.bind(null, clearFields, setIsDirty, setIsConfirmClearAllDialogOpen),
        // },
        makeProfilePublicDialog: {
            maxWidth: 'sm',
            title: 'Edit Your Profile?',
            onClose: () => setMakePofilePublicDialog(false),
            onConfirm: onConfrimChangeProfileType,
            open: makeProfilePublicDialog,
            message: CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT,
        },
        badImageDialog: {
            title: 'Inappropriate Images are not Allowed!',
            children: (
                <AfitdTypography>
                    We detected <b>{badImageDialogMessage}</b> in your picture which does not meet our community guidelines. Inappropriate Images cannot be saved to this platform.
                </AfitdTypography>
            ),
            open: openBadImageDialog,
            onClose: async () => {
                setOpenBadImageDialog();
                handleCloseCropBanneroModal();
                handleCloseCropLogoModal();
                await resetEmpBrandingSeResults({ employerId, setSnackbarMessage, setSnackbarErrorMessage });
            },
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const BrandingLogoSection = props => {
    if (props.isHidden) return null;
    const { defns, isPublic } = props;
    const buttonLabel = defns.uploadLogoButton.label;

    return (
        <div {...defns.brandingLogoContainer}>
            <div {...defns.imageSectionTop}>
                <div>
                    <BrandingLogoPreview {...defns.brandingLogoPreview} />
                </div>
                <div {...defns.logoDiv}>
                    <h4>
                        <b>Company Logo</b>
                    </h4>
                    <p {...defns.logoDetails}>JPG and PNG files are the accepted file types.</p>
                    <div>
                        <AfitdButton {...defns.uploadLogoButton}>
                            {buttonLabel}
                            {!isPublic && <input {...defns.logoUploadInput} />}
                        </AfitdButton>
                        <AfitdButton {...defns.deleteLogoButton}>Delete</AfitdButton>
                    </div>
                </div>
            </div>
            <div {...defns.imageSectionBottom}>
                <AfitdTypography {...defns.logoErrorText} />
            </div>
        </div>
    );
};

const BrandingBannerSection = props => {
    if (props.isHidden) return null;
    const { defns, isPublic } = props;
    const buttonLabel = defns.uploadBannerButton.label;

    return (
        <div {...defns.brandingBannerContainer}>
            <div {...defns.imageSectionTop}>
                <div>
                    <BrandingBannerPreview {...defns.brandingBannerPreview} />
                </div>
                <div>
                    <div {...defns.bannerDiv}>
                        <h4>
                            <b>Banner/ Branded Backdrop</b>
                        </h4>
                        <p {...defns.bannerDetails}>JPG and PNG files are the accepted file types.</p>
                        <div>
                            <AfitdButton {...defns.uploadBannerButton}>
                                {buttonLabel}
                                {!isPublic && <input {...defns.bannerUploadInput} />}
                            </AfitdButton>
                            <AfitdButton {...defns.deleteBannerButton}>Delete</AfitdButton>
                        </div>
                    </div>
                </div>
            </div>
            <div {...defns.imageSectionBottom}>
                <AfitdTypography {...defns.bannerErrorText} />
            </div>
        </div>
    );
};

const allowedFileTypes = ['.png', '.jpg'];

const validateFileType = file => {
    const filename = _get(file, 'name', '');
    const extension = _toUpper(`.${_last(filename.split('.'))}`);
    const isTypeAllowed = _some(allowedFileTypes, item => _toUpper(item) === extension);
    return isTypeAllowed;
};

const validateFileSize = file => {
    const size = _get(file, 'size', 0);
    const isSizeAllowed = size <= 5000000; // 5MB
    return isSizeAllowed;
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Branding = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    const { employerId, currentEmployer } = useContext(AppContext);
    const { setSnackbarMessage, setSnackbarErrorMessage } = useContext(LayoutContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const logoInputRef = useRef();
    const bannerInputRef = useRef();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { data, isPublic, profileData } = props;
    const profilePicUrl = _get(data, 'profilePicUrl');

    // const profilePicUrl = _get(data, 'profilePicUrl');
    const bannerUrl = _get(data, 'bannerUrl');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [logoImage, setLogoImage] = useState('');
    const [bannerImage, setBannerImage] = useState('');
    const [logoBlob, setLogoBlob] = useState(null);
    const [bannerBlob, setBannerBlob] = useState(null);
    const [cropLogoModalOpen, setCropLogoModalOpen] = useState(false);
    const [cropBannerModalOpen, setCropBannerModalOpen] = useState(false);
    const [source, setSource] = useState('');
    const [sourceBanner, setSourceBanner] = useState('');
    // const [isBannerImage, setIsBannerImage] = useState(false);
    const [progress, setProgress] = useState(null);
    // const [isDirty, setIsDirty] = useState(false);
    // const [isConfirmClearAllDialogOpen, setIsConfirmClearAllDialogOpen] = useState(false);
    // const [isConfirmCloseDialogOpen, setIsConfirmCloseDialogOpen] = useState(false);
    const [isConfirmDeleteLogoDialogOpen, setIsConfirmDeleteLogoDialogOpen] = useState(false);
    const [isConfirmDeleteBannerDialogOpen, setIsConfirmDeleteBannerDialogOpen] = useState(false);
    const [logoErrorMessage, setLogoErrorMessage] = useState(null);
    const [bannerErrorMessage, setBannerErrorMessage] = useState(null);
    const [makeProfilePublicDialog, setMakePofilePublicDialog] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [openBadImageDialog, setOpenBadImageDialog] = useState(false);
    const [badImageDialogMessage, setBadImageDialogMessage] = useState([]);
    const [isPictureProcessing, setIsPictureProcessing] = useState(false);
    const [isBannerProcessing, setIsBannerProcessing] = useState(false);

    //   console.log(logoImage);
    // console.log('logoBlob', logoBlob);
    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // init
    // useEffect(() => {
    //     setSource(profilePicUrl);
    // }, [profilePicUrl]);

    // useEffect(() => {
    //     setSourceBanner(bannerUrl);
    // }, [bannerUrl]);

    // selected image
    useEffect(() => {
        if (logoBlob) {
            // let url = URL.createObjectURL(logoBlob);
            // setSource(url);
            // clear the file input
            _set(logoInputRef, 'current.value', null);
        }
    }, [logoBlob]);

    useEffect(() => {
        if (bannerBlob) {
            // let url = URL.createObjectURL(bannerBlob);
            // setSourceBanner(url);
            // clear the file input
            _set(bannerInputRef, 'current.value', null);
        }
    }, [bannerBlob]);

    // Detect SightEngine Response
    useEffect(() => {
        let seResult = _get(currentEmployer, 'seResult');
        const uploadedPictureStatus = _get(currentEmployer, 'uploadedPictureStatus');

        if (seResult) extractBadContentFromResult({ seResult, setBadImageDialogMessage, setOpenBadImageDialog });

        if (uploadedPictureStatus === UPLOADED_VIDEO_STATUS_PROCESSING) setIsPictureProcessing(true);
        else {
            setIsPictureProcessing(false);
            setSource(profilePicUrl);
        }
    }, [currentEmployer, profilePicUrl]);

    useEffect(() => {
        const seResultEmpProfile = _get(profileData, 'seResult');
        const uploadedPictureStatusEmpProfile = _get(profileData, 'uploadedPictureStatus');

        if (seResultEmpProfile) extractBadContentFromResult({ seResult: seResultEmpProfile, setBadImageDialogMessage, setOpenBadImageDialog });

        if (uploadedPictureStatusEmpProfile === UPLOADED_VIDEO_STATUS_PROCESSING) setIsBannerProcessing(true);
        else {
            setIsBannerProcessing(false);
            setSourceBanner(bannerUrl);
        }
    }, [profileData, bannerUrl]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const onConfrimChangeProfileType = async () => {
        await changeEmpProfileToDraft({ employerId, setSnackbarMessage, setSnackbarErrorMessage });
    };
    // upload logo
    const handleChangeLogoUploadInput = evt => {
        const file = evt.target.files[0];

        if (file) {
            let errorMessage = null;
            if (!validateFileType(file)) {
                errorMessage = ERROR_MESSAGE_FILE_NOT_ALLOWED;
            } else if (!validateFileSize(file)) {
                errorMessage = ERROR_MESSAGE_FILE_SIZE_NOT_OVER_5MB;
            }

            if (errorMessage) {
                setLogoErrorMessage(errorMessage);
            } else {
                setLogoImage(file);
                // setIsDirty(true);
                setCropLogoModalOpen(true);
                setLogoErrorMessage(null);
            }
        }
    };

    // upload banner
    const handleChangeBannerUploadInput = evt => {
        const file = evt.target.files[0];

        if (file) {
            let errorMessage = null;
            if (!validateFileType(file)) {
                errorMessage = ERROR_MESSAGE_FILE_NOT_ALLOWED;
            } else if (!validateFileSize(file)) {
                errorMessage = ERROR_MESSAGE_FILE_SIZE_NOT_OVER_15MB;
            }

            if (errorMessage) {
                setBannerErrorMessage(errorMessage);
            } else {
                setBannerImage(file);
                // setIsDirty(true);
                setCropBannerModalOpen(true);
                setBannerErrorMessage(null);
            }
        }
    };

    // save

    const handleUploadLogo = async () => {
        setSaveLoading(true);

        await saveProfileBranding({
            logoFile: logoBlob,
            employerId,
            setSnackbarMessage,
            setSnackbarErrorMessage,
            setProgress,
            closeCropper: () => {
                let url = URL.createObjectURL(logoBlob);
                setSource(url);
                setCropLogoModalOpen(false);
                setSaveLoading(false);
            },
        });
    };

    const handleUploadBanner = async () => {
        setSaveLoading(true);

        await saveProfileBranding({
            bannerFile: bannerBlob,
            employerId,
            setSnackbarMessage,
            setSnackbarErrorMessage,
            setProgress,
            closeCropper: () => {
                let url = URL.createObjectURL(bannerBlob);
                setSourceBanner(url);
                setCropBannerModalOpen(false);
                setSaveLoading(false);
            },
        });
    };

    // // clear all
    // const handleCloseConfirmClearAllDialog = () => {
    //     setIsConfirmClearAllDialogOpen(false);
    // };

    // const handleClickConfirmClearAllDialogYes = () => {
    //     setIsConfirmClearAllDialogOpen(false);
    //     clearFields();
    //     setIsDirty(true);
    // };

    // const handleClickClearAllButton = () => {
    //     setIsConfirmClearAllDialogOpen(true);
    // };

    // const clearFields = () => {
    //     setLogoImage('');
    //     setBannerImage('');
    //     setSource('');
    //     setSourceBanner('');
    //     setLogoBlob(null);
    //     setIsDirty(true);
    // };

    // // cancel
    // const handleClickCancelButton = () => {
    //     setIsConfirmCloseDialogOpen(true);
    // };

    // const handleCloseConfirmCancelDialog = () => {
    //     setIsConfirmCloseDialogOpen(false);
    // };

    // const handleClickConfirmCancelDialogYes = () => {
    //     setIsConfirmCloseDialogOpen(false);
    //     setLogoImage('');
    //     setBannerImage('');
    //     setIsBannerImage(false);
    //     setSource(profilePicUrl);
    //     setSourceBanner('');
    //     setIsDirty(false);
    // };

    // close cropper
    const handleCloseCropLogoModal = () => {
        setCropLogoModalOpen(false);
        // handleClickConfirmCancelDialogYes();
        _set(logoInputRef, 'current.value', null);
        setLogoBlob(null);
    };

    const handleCloseCropBanneroModal = () => {
        setCropBannerModalOpen(false);
        // handleClickConfirmCancelDialogYes();
        _set(bannerInputRef, 'current.value', null);
        setBannerBlob(null);
    };

    // delete logo
    const handleClickDeleteLogoButton = () => {
        setIsConfirmDeleteLogoDialogOpen(true);
    };

    const handleCloseConfirmDeleteLogoDialog = () => {
        setIsConfirmDeleteLogoDialogOpen(false);
    };

    const handleClickConfirmDeleteLogoDialogYes = () => {
        deleteCompanyLogo({
            employerId,
            profilePicUrl,
            setSnackbarMessage,
            setSnackbarErrorMessage,
            postDelete: () => {
                setSource('');
            },
        });
    };

    // delete banner
    const handleClickDeleteBannerButton = () => {
        setIsConfirmDeleteBannerDialogOpen(true);
    };

    const handleCloseConfirmDeleteBannerDialog = () => {
        setIsConfirmDeleteBannerDialogOpen(false);
    };

    const handleClickConfirmDeleteBannerDialogYes = () => {
        deleteCompanyBanner({
            employerId,
            bannerUrl,
            setSnackbarMessage,
            setSnackbarErrorMessage,
            postDelete: () => {
                setSourceBanner('');
            },
        });
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        currentEmployer,
        props,
        source,
        setSource,
        sourceBanner,
        setSourceBanner,
        logoImage,
        bannerImage,
        logoBlob,
        setLogoBlob,
        bannerBlob,
        setBannerBlob,
        logoInputRef,
        bannerInputRef,
        progress,
        setProgress,
        // isDirty,
        // setIsDirty,
        // isConfirmClearAllDialogOpen,
        // setIsConfirmClearAllDialogOpen,
        // isConfirmCloseDialogOpen,
        // setIsConfirmCloseDialogOpen,
        isConfirmDeleteLogoDialogOpen,
        setIsConfirmDeleteLogoDialogOpen,
        isConfirmDeleteBannerDialogOpen,
        setIsConfirmDeleteBannerDialogOpen,
        // clearFields,
        handleChangeLogoUploadInput,
        handleChangeBannerUploadInput,
        // handleClickClearAllButton,
        // handleCloseConfirmClearAllDialog,
        // handleClickConfirmClearAllDialogYes,
        // handleClickCancelButton,
        // handleCloseConfirmCancelDialog,
        // handleClickConfirmCancelDialogYes,
        handleClickDeleteLogoButton,
        handleCloseConfirmDeleteLogoDialog,
        handleClickConfirmDeleteLogoDialogYes,
        handleClickDeleteBannerButton,
        handleCloseConfirmDeleteBannerDialog,
        handleClickConfirmDeleteBannerDialogYes,
        handleUploadLogo,
        handleUploadBanner,
        cropLogoModalOpen,
        setCropLogoModalOpen,
        cropBannerModalOpen,
        setCropBannerModalOpen,
        handleCloseCropLogoModal,
        handleCloseCropBanneroModal,
        logoErrorMessage,
        setLogoErrorMessage,
        bannerErrorMessage,
        setBannerErrorMessage,
        makeProfilePublicDialog,
        setMakePofilePublicDialog,
        onConfrimChangeProfileType,
        saveLoading,
        openBadImageDialog,
        setOpenBadImageDialog,
        badImageDialogMessage,
        isPictureProcessing,
        isBannerProcessing,
        employerId,
        setSnackbarMessage,
        setSnackbarErrorMessage,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.header}>
                <div {...defns.titleContainer}>
                    <AfitdTypography {...defns.titleText} />
                </div>
            </div>
            <BrandingLogoSection {...defns.brandingLogoSection} defns={defns} isPublic={isPublic} />
            <BrandingBannerSection {...defns.brandingBannerSection} defns={defns} isPublic={isPublic} />
            {/* <div {...defns.uploadLinearProgressContainer}>
                <AfitdLinearProgress {...defns.uploadLinearProgress} />
            </div> */}
            {/* <div {...defns.footerButtons}>
                <div>
                    <AfitdButton {...defns.clearAllButton}>Clear All</AfitdButton>
                </div>
                <div>
                    <AfitdButton {...defns.cancelButton}>Cancel</AfitdButton>
                    &nbsp; &nbsp;
                    <AfitdButton {...defns.saveButton}>Save Changes </AfitdButton>
                </div>
            </div> */}
            {cropLogoModalOpen && (
                <AfitdEditDialog {...defns.cropLogoModal}>
                    <div {...defns.imgBeforeCropContainer}>
                        <AfitdProfilePicCropper {...defns.logoCropper} />
                    </div>
                    <div {...defns.uploadLinearProgressContainer}>
                        <AfitdLinearProgress {...defns.logoUploadLinearProgress} />
                    </div>
                </AfitdEditDialog>
            )}
            {cropBannerModalOpen && (
                <AfitdEditDialog {...defns.cropBannerModal}>
                    <div {...defns.imgBeforeCropContainer}>
                        <AfitdBannerCropper {...defns.bannerCropper} />
                    </div>
                    <div {...defns.uploadLinearProgressContainer}>
                        <AfitdLinearProgress {...defns.bannerUploadLinearProgress} />
                    </div>
                </AfitdEditDialog>
            )}
            <AfitdConfirmDialog {...defns.confirmDeleteLogoDialog} />
            <AfitdConfirmDialog {...defns.confirmDeleteBannerDialog} />
            <AfitdConfirmDialog {...defns.makeProfilePublicDialog} />
            <AfitdMessageDialog {...defns.badImageDialog} />

            {/* <AfitdConfirmDialog {...defns.confirmClearAllDialog} /> */}
            {/* <AfitdConfirmDialog {...defns.confirmCancelDialog} /> */}
        </div>
    );
};

export default Branding;
